<template>
  <textarea
    v-if="multiline"
    ref="inputRef"
    :value="value"
    :class="[$style.root, $style.textarea]"
    :style="{ width }"
    v-bind="$props"
    @input="$emit('input', $event.target.value)"
    @keypress="handleKeyPress"
  />
  <input
    v-else
    ref="inputRef"
    :value="value"
    :class="[
      $style.root,
      { [$style.compact]: compact }
    ]"
    :style="{ width }"
    v-bind="$props"
    @input="$emit('input', $event.target.value)"
    @keypress="handleKeyPress"
  >
</template>

<script>
export default {
  name: 'TextInput',
  props: {
    value: {
      type: String,
      default: undefined,
    },
    width: {
      type: String,
      default: '100%',
    },
    compact: {
      type: Boolean,
      default: false,
    },
    initialFocus: {
      type: Boolean,
      default: false,
    },
    multiline: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    if (this.initialFocus) {
      this.$refs.inputRef.focus();
    }
  },
  methods: {
    handleKeyPress($event) {
      if ($event.keyCode === 13) {
        this.$emit('press-enter');
      }
    },
  },
}
</script>

<style lang="scss" module>
  @import '_theme/main';

  .root {
    outline: none;
    background: $bg-accented-color;
    height: $input-height;
    border: $input-border;
    padding: 0 $input-horizontal-padding;
    color: $text-primary-color;
    border-radius: $border-radius-input;
    transition: border-color $standart-transition;

    &.compact {
      height: 30px;
      padding: 0 $gap-xs;
    }

    &.textarea {
      padding: $gap-s;
      height: auto;
    }

    &:focus {
      border-color: $input-focused-border-color;
    }

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    &[type=number] {
      -moz-appearance: textfield;
    }

    &::placeholder {
      color: $text-secondary-color;
    }
  }
</style>
